import {
  type ReferentialEnum,
  referentialEnumToReferentialCodeList,
} from "@pharmupp/p3-front-commons"

export const newsRubricsEnum = {
  UPP_GROUP: {
    label: "Pharm-UPP vous informe",
    shortLabel: "Pharm-UPP vous informe",
  },
  LAB_EXTERN: {
    label: "Actualités Labos & Prestataires",
    shortLabel: "Labos & Prestataires",
  },
  HEALTH_PHARMA: {
    label: "Actualités Santé & Pharma",
    shortLabel: "Santé & Pharma",
  },
} as const satisfies ReferentialEnum<{ shortLabel: string }>
export const newsRubricsReferential =
  referentialEnumToReferentialCodeList(newsRubricsEnum)
export type NewsRubricsName = keyof typeof newsRubricsEnum

// EVENTS
const { HEALTH_PHARMA, ...newsEventRubricsEnum } = newsRubricsEnum
export const newsEventRubricsReferential =
  referentialEnumToReferentialCodeList(newsEventRubricsEnum)
export type NewsEventRubricsName = keyof typeof newsEventRubricsEnum
